var _polyline, _polygon, _path, _circle, _path2, _rect, _path3, _polygon2, _polygon3, _path4, _path5, _path6, _circle2, _polygon4, _path7, _polygon5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _circle3, _circle4, _rect2, _rect3, _rect4, _circle5, _rect5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e964fae6-99d5-4ba3-9654-9b5776c78265",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1002.69775,
    height: 700.07656,
    viewBox: "0 0 1002.69775 700.07656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design_data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "482.698 151.17 482.698 280.17 728.698 280.17",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "764.698 281.17 481.698 281.17 481.698 26.17 483.698 26.17 483.698 279.17 764.698 279.17 764.698 281.17",
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584.43579,381.42112l-1.78906-.89453c12.30078-24.61181,37.958-42.07031,65.36621-44.47656,4.72852-.41553,9.68262-.45654,14.47363-.49609,13.24024-.10987,26.93067-.22315,36.91309-8.31934,7.38965-5.99268,10.96191-14.80713,14.74414-24.13916a119.55826,119.55826,0,0,1,6.48437-14.18994,58.17306,58.17306,0,0,1,46.1211-28.6582c.73047-.04249,1.47558-.06836,2.23144-.07666a54.781,54.781,0,0,1,5.29688-6.08643c9.6914-9.58447,22.10058-15.86719,34.10156-21.94287l2.84082-1.44043c12.69922-6.46143,25.85059-13.7085,34.83106-24.93555a55.14771,55.14771,0,0,0,8.82031-51.50879l1.88867-.6582a57.19247,57.19247,0,0,1-9.14648,53.416c-9.23047,11.53857-22.5918,18.90869-35.48731,25.46875l-2.84375,1.44238c-11.86328,6.00635-24.13086,12.21679-33.59863,21.58056a52.813,52.813,0,0,0-4.208,4.69971c11.30176.44434,24.44922,4.80615,31.83691,16.10645a28.05272,28.05272,0,0,1,3.28223,22.41015c-1.78223,6.55908-5.75195,11.65625-11.17871,14.353-5.72949,2.84717-12.501,2.76465-19.06738-.2334A28.939,28.939,0,0,1,760.471,294.41673c-3.02344-11.68848.958-23.2544,7.05176-32.20606q-.32812.01392-.65821.0337a56.12623,56.12623,0,0,0-44.498,27.64941,118.04957,118.04957,0,0,0-6.36817,13.95312c-3.71191,9.15625-7.54883,18.624-15.33887,24.94141-10.52539,8.53662-24.57226,8.65283-38.15625,8.76563-4.75195.03955-9.666.08007-14.31445.48828C621.4563,340.38939,596.43286,357.41673,584.43579,381.42112ZM769.99243,262.16624c-6.27246,8.69336-10.57617,20.18848-7.58594,31.74951a26.90008,26.90008,0,0,0,14.77344,17.10694c6.00684,2.7417,12.168,2.835,17.3457.26171,4.90821-2.439,8.50879-7.08642,10.13965-13.08642a26.38691,26.38691,0,0,0-3.02636-20.791C795.53735,268.074,783.344,262.27659,769.99243,262.16624Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 620.69775,
    cy: 193.17034,
    r: 18,
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531.61938,620.08421H98.65112V414.13206H531.61938Zm-430.96826-2H529.61938V416.13206H100.65112Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 322.69775,
    y: 675.17034,
    width: 665,
    height: 2,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M931,332.46l-8.22373,41.1187s-10.57338,23.49639-5.8741,39.94387l3.52446,7.04892,22.32157-19.97194,8.22374-55.21653Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.531 613.14 773.608 662.482 788.881 669.531 802.978 657.783 811.202 620.189 786.531 613.14",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "959.817 593.755 966.278 664.832 999.173 664.832 983.313 586.706 959.817 593.755",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.36329,432.31968l6.65577-32.54141-77.145-17.97585-16.44747,25.846S892.231,452.29161,885.182,588.57071,875.78347,723.675,875.78347,723.675l57.56617,5.8741,29.3705-190.32081L1035.559,713.10161,1090.7755,697.829,1021.46113,488.711S1026.16041,458.16571,1007.36329,432.31968Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M888.70649,751.87067l-8.22374,8.22373-4.69928-4.69927,2.56541-17.26307-13.13879,7.86451s-23.49639-3.52446-21.14675,21.14675c0,0-3.52446,8.22374,16.44748,17.6223s30.54531,15.27266,30.54531,15.27266,18.79712-1.17482,18.79712-7.04892-5.92335-45.76067-5.92335-45.76067Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.20212,751.87067l-8.22374,8.22373-4.69928-4.69927-4.93022-17.26307-5.64316,7.86451s-23.49639-3.52446-21.14675,21.14675c0,0-3.52446,8.22374,16.44747,17.6223s30.54532,15.27266,30.54532,15.27266,18.79712-1.17482,18.79712-7.04892-5.92335-45.76067-5.92335-45.76067Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.74023,
    cy: 130.28895,
    r: 34.06977,
    fill: "#a0616a"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "878.167 156.135 880.516 196.079 925.16 196.079 912.237 142.037 878.167 156.135",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M950.97194,279.5931l36.41942-2.34964,38.769,2.34964s32.895,17.6223,15.27266,65.78991-30.54532,63.44027-30.54532,63.44027L973.29352,392.3758h-11.7482s-3.52446-3.52446-4.69928-3.52446-23.4964,3.52446-23.4964,3.52446-5.8741-24.67121,2.34964-27.02085,12.923-15.27266,12.923-15.27266Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#d0cde1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "859.37 183.156 852.321 179.631 827.65 237.198 854.67 254.82 859.37 183.156",
    fill: "#d0cde1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M938.63633,227.31362s-16.44747-42.29351,16.06742-46.34061c0,0,40.99641-25.18314,67.34479,16.97011l20.79395,51.32744-6.947-1.38084-.88176,6.91568-8.86417,5.438-6.66707-6.89016,1.10275,10.54778-76.37657,32.436s28.795-31.88692,17.68741-69.48181l-4.50911,9.20318Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M463.65064,750.5433c-4.27162,15.79047-18.90288,25.56991-18.90288,25.56991s-7.7056-15.822-3.434-31.61245,18.90288-25.56991,18.90288-25.56991S467.92226,734.75283,463.65064,750.5433Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M424.79081,750.5433c4.27162,15.79047,18.90288,25.56991,18.90288,25.56991s7.7056-15.822,3.434-31.61245-18.90288-25.56991-18.90288-25.56991S420.51919,734.75283,424.79081,750.5433Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M431.06766,747.14976c11.72138,11.4103,13.15307,28.95058,13.15307,28.95058s-17.57245-.95946-29.29383-12.36976S401.77383,734.78,401.77383,734.78,419.34627,735.73946,431.06766,747.14976Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M457.3738,747.14976c-11.72139,11.4103-13.15307,28.95058-13.15307,28.95058s17.57244-.95946,29.29382-12.36976S486.66762,734.78,486.66762,734.78,469.09518,735.73946,457.3738,747.14976Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.47676,184.81109a84.77128,84.77128,0,0,1,62.0245-57.85165,84.82692,84.82692,0,1,0-42.92415,140.48949A84.77106,84.77106,0,0,1,285.47676,184.81109Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.00729,132.32821a84.40225,84.40225,0,0,0-43.88661-1.51312,84.8062,84.8062,0,0,1-42.92416,140.48948,84.82248,84.82248,0,1,0,86.81077-138.97636Z",
    transform: "translate(-98.65112 -99.96172)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.4475,
    cy: 198.85663,
    rx: 73.45032,
    ry: 42.41343,
    transform: "translate(-54.23012 357.77171) rotate(-73.01039)",
    fill: "#d0cde1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.69775,
    cy: 59.17034,
    r: 18,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.69775,
    cy: 133.17034,
    r: 18,
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.69775,
    y: 360.81485,
    width: 329.07358,
    height: 145.35549,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.04391,
    y: 351.04697,
    width: 313.3235,
    height: 27.80089,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.95536,
    y: 361.19054,
    width: 273.50061,
    height: 7.51375,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.32998,
    cy: 364.57172,
    r: 10.51925,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.43007,
    y: 400.63774,
    width: 163.79982,
    height: 78.14303,
    fill: "#6c63ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.32998,
    cy: 439.70926,
    r: 15.02751,
    opacity: 0.15
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.92625,
    cy: 439.70926,
    r: 15.02751,
    fill: "#fff",
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.73371,
    cy: 439.70926,
    r: 15.02751,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.6a729f959f101b2c980f6f4736efdeb6.svg";
export { ForwardRef as ReactComponent };